

const DashboardTable = ({ title, type, rows }) => {
  return (
    <div className="dashboard_table" style={{ marginBottom: "20px" }}>
      <h5 style={{ fontWeight: "600", marginBottom: "10px", color: "#4b0082" }}>
        {title}
      </h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="back1">Doctype</th>
            <th className="back2"> {type ? 'No.': 'Pending'}</th>
            <th className="back3">{type ? 'Quantity': 'Process'}</th>
            <th className="back4">{type ? 'Value': 'Complete'}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx}>
              <td>{row.transaction}</td>
              <td>{row.no ?? "-"}</td>
              <td>{row.qty ?? "-"}</td>
              <td>{row.value ?? "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


export default DashboardTable